import { Card, Form, Input, Button, Typography } from "antd";
import { Mail, Phone, MapPin, Clock, PersonStanding } from "lucide-react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useLanguage } from "../../../context/LanguageContext";
import content from "../../../utils/content";

const { Title, Text } = Typography;
const { TextArea } = Input;

export const ContactSection = () => {
  const { language } = useLanguage();
  const t = content[language].contact;

  const onFinish = (values) => {
    console.log("Form submitted:", values);
  };

  // Intersection Observer für Animation
  const [formRef, formInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const [cardRef, cardInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const fadeIn = (delay = 0, x = 0, y = 0) => ({
    hidden: { opacity: 0, x, y },
    visible: { opacity: 1, x: 0, y: 0, transition: { duration: 1, delay } },
  });

  return (
    <div className="w-full px-4 md:px-6 py-12 md:py-24">
      <div className="grid gap-12 lg:grid-cols-2">
        {/* Formular mit Animation */}
        <motion.div
          ref={formRef}
          initial="hidden"
          animate={formInView ? "visible" : "hidden"}
          variants={fadeIn(0, -50, 0)}
          className="space-y-6"
        >
          <div className="space-y-2">
            <Title
              level={2}
              className="!text-4xl md:!text-5xl font-bold tracking-tight"
            >
              {t.title}
            </Title>
            <Text className="text-gray-500">{t.description}</Text>
          </div>

          <Form
            name="contact"
            onFinish={onFinish}
            layout="vertical"
            className="space-y-4"
          >
            <Form.Item
              name="name"
              rules={[{ required: true, message: t.form.nameError }]}
            >
              <Input placeholder={t.form.namePlaceholder} size="large" />
            </Form.Item>

            <Form.Item
              name="email"
              rules={[
                { required: true, message: t.form.emailError },
                { type: "email", message: t.form.emailInvalidError },
              ]}
            >
              <Input placeholder={t.form.emailPlaceholder} size="large" />
            </Form.Item>

            <Form.Item
              name="message"
              rules={[{ required: true, message: t.form.messageError }]}
            >
              <TextArea placeholder={t.form.messagePlaceholder} rows={4} />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                className="w-full bg-[#FF7051] hover:!bg-[#FF7051]/90"
              >
                {t.form.submitButton}
              </Button>
            </Form.Item>
          </Form>
        </motion.div>

        {/* Info-Card mit Animation */}
        <motion.div
          ref={cardRef}
          initial="hidden"
          animate={cardInView ? "visible" : "hidden"}
          variants={fadeIn(0.3, 50, 0)} // Verzögerung + Slide von rechts
        >
          <Card className="bg-[#FF7051] text-white">
            <Title level={3} className="!text-white mb-6">
              {t.infoCard.title}
            </Title>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <PersonStanding className="w-5 h-5" />
                <Text className="text-white">{t.infoCard.name}</Text>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-5 h-5" />
                <Text className="text-white">{t.infoCard.email}</Text>
              </div>
              <div className="flex items-center gap-3">
                <Clock className="w-5 h-5" />
                <Text className="text-white">{t.infoCard.hours}</Text>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>
    </div>
  );
};
